// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { WizardDeviceStepsEnum } from "./Shared.WizardDeviceStepsEnum.gen";

export interface IWizardSteps {
	id: string | undefined;

	dateCreated: string | undefined;

	organizationId: string | undefined;

	facilityGroupId: string | undefined;

	facilityId: string | undefined;

	userId: string | undefined;

	deviceId: string | undefined;

	currentStep: WizardDeviceStepsEnum;

	isDeleted: boolean;

	$type?: string | undefined;
}
export class WizardSteps {
	constructor(data?: IWizardSteps) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
	}

	id: string | undefined;

	dateCreated: Date | undefined = new Date();

	organizationId: string | undefined;

	facilityGroupId: string | undefined;

	facilityId: string | undefined;

	userId: string | undefined;

	deviceId: string | undefined;

	currentStep: WizardDeviceStepsEnum = 0;

	isDeleted: boolean = false;

	static $type: string = "CoreApi.Models.WizardSteps, ";
	$type?: string | undefined = WizardSteps.$type;
}

